module.exports = __webpack_public_path__ + "static/media/lupa.a491d01a.svg";